import React, { useEffect, useState } from "react";
import {Modal, Button} from 'react-bootstrap';
import { useSelector } from "react-redux";
import ConfirmationModal from '../Controls/ConfirmationModal';
import APICom from "../../utils/helpers/APICom";
import moment from "moment/moment";


const DueNow = (props) => {

    const { loginData }  = useSelector((store) => store.login);
    const { ASCSSettingData }  = useSelector((store) => store.combinedata);
    const [isComponentLoading, setIsComponentLoading] = useState(true);
    const [showDueNowAlert, setShowDueNowAlert] = useState(false);
    const [DueNowAlert, setDueNowAlert] = useState({alertTitle : '', alertMsg: ''});
    const[dueNoweObj, setDueNowObj] = useState({iRefID: '-1', ServiceID: '-1', iATSPID: '-1', 
    bReturnLeg:'false', SDID: '-1', iUserID:'-1', iAppID: '5',
    iAssignedVehicleId: '-1', AssignedDriverId: '-1', Queue: ''});
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Service Hours Warning!',
    body: '', btnCanceText: 'No',
    btnOkText: 'Yes'});

    useEffect(() => {
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            setDueNowAlert({...DueNowAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to perform due-now.'});
            setShowDueNowAlert(true);
        }
        else if(props.GridRowData.length > 1)
        {
            setDueNowAlert({...DueNowAlert, alertTitle: 'Multiple trips selected', alertMsg:'Please select one trip to perform due-now.'});
            setShowDueNowAlert(true);
        }
        else
        {
            const gData = props.GridRowData[0];
            if(gData.CreatedBy === "(ExternalDispatch)")
            {
                setDueNowAlert({...DueNowAlert, alertTitle: 'Due Now Restriction', alertMsg:'Due Now is not allowed for Broker Trip!'});
                setShowDueNowAlert(true);
            }
            else
            {
                let MultiScheduleWillCallArray = [];
                var SelectedRows = props.GridRowData;
                for (let dr = 0; dr < SelectedRows.length; dr++)
                {
                    var MultiScheduleWillCallObj = {
                        "iRefID": "-1",
                        "iScheduleID": "-1",
                        "iScheduleDetailID": "-1",
                        "bSReturnTrip": "false",
                        "PickupDateTime": "01/01/1900"
                    }
                    if (parseInt(SelectedRows[dr].SchDetailID) > 0 && SelectedRows[dr].IsReturnTrip.toString().toLowerCase() == "false")
                    {
                        MultiScheduleWillCallObj.iRefID = SelectedRows[dr].ConfirmationNo;
                        MultiScheduleWillCallObj.iScheduleID = (SelectedRows[dr].iScheduleID === undefined) ? "-1": SelectedRows[dr].iScheduleID.toString();
                        MultiScheduleWillCallObj.iScheduleDetailID = SelectedRows[dr].SchDetailID.toString();
                        MultiScheduleWillCallObj.bSReturnTrip = SelectedRows[dr].IsReturnTrip.toString().toLowerCase();
                        MultiScheduleWillCallObj.PickupDateTime = SelectedRows[dr].PickupDateTime;
                        MultiScheduleWillCallArray.push(MultiScheduleWillCallObj);
                    }
                }
                if(MultiScheduleWillCallArray.length > 0)
                {
                    checkMultiScheduleWillCallExtendedTrip(MultiScheduleWillCallArray);
                }
                else
                {
                    var checkServiceHours = {
                        "iATSPID": gData.iSRATSPID.toString(),
                        "EstimatedTime": gData.EstimatedTime,
                        "iClientID": gData.ClientID.toString(),
                        "vPickUpZone": gData.PZONE
                    }
                    CheckServiceHours(checkServiceHours);
                }
            }

            
        }
    }, []);

    const checkMultiScheduleWillCallExtendedTrip = async(MultiScheduleWillCallArray) => {
        let multischedulewc = MultiScheduleWillCallArray;
        let response = await APICom.fetchData("", "TripActions/checkMultiScheduleWillCallExtendedTripMulti", "post", { "Content-Type": "application/json" }, multischedulewc, null);
        let result = response.data;
        if (result.proceed.toString().toLowerCase() === "false") {
            setDueNowAlert({...DueNowAlert, alertTitle: 'Expand Multi-Schedule', alertMsg:`ConfirmationNo : " ${result.iRefID.toString()} " has a master leg, which is not yet expanded. Please first expand master leg by 'Assign' or 'Due-Now' action.`});
            setShowDueNowAlert(true);
        }
        else
        {
            let gData = props.GridRowData[0];
            var checkServiceHours = {
                "iATSPID": gData.iSRATSPID.toString(),
                "EstimatedTime": gData.EstimatedTime,
                "iClientID": gData.ClientID.toString(),
                "vPickUpZone": gData.PZONE
            }
            CheckServiceHours(checkServiceHours);
        }
    }

    const CheckServiceHours = async(checkServiceHours) => {
        let response = await APICom.fetchData("", "TripActions/CheckServiceHours", "post", { "Content-Type": "application/json" }, checkServiceHours, null);
        let result = response.data;
        if(result !== '' && Boolean(result[0]["STATUS"]))
        {
            GetCurrentServerTime();
        }
        else if(result[0]["STATUS"].toString().toLowerCase() === 'false' && result[0]["MESSAGE"].toLowerCase().includes('same day reservation is not allowed'))
        {
            GetCurrentServerTime();
        }
        else
        {
            setConfirmationModalObj((prevState) => ({...prevState, show:true, body: result["MESSAGE"] + " Would you like to proceed with 'Due now'?"}));
        }
        
    }

    const GetCurrentServerTime = async() => {
        let Msg = '';
        let response = await APICom.fetchData("", "TripActions/GetCurrentDBDateTime", "post", { "Content-Type": "application/json" }, {}, null);
        let GetAlerts_ServerTime = response.data;
        let dtPuDateObj = props.GridRowData[0].PickupDateTime;
        if (dtPuDateObj != "" && GetAlerts_ServerTime != "") {
            dtPuDateObj = moment(dtPuDateObj, "MM/DD/YYYY h:mmA");
            let GetAlerts_ServerTime_value = moment(GetAlerts_ServerTime, "MM/DD/YYYY h:mmA");
            if (dtPuDateObj.isValid()) {
                if (GetAlerts_ServerTime_value.isValid()) {
                    let diffDays = Math.abs(date_diff_indays(dtPuDateObj, GetAlerts_ServerTime_value));
                    if (diffDays > 0) {
                        //Allegany Change: Imran ask to restrict future date Due-Now. 
                        Msg = "Confirmation# '" + props.GridRowData[0].ConfirmationNo + "'with schedule time '" + dtPuDateObj.format("MM/DD/YYYY hh:mm a") + "' is not scheduled for today. Due-Now cannot be performed on future date trip."
                    }
                }
            }
        }
        if(Msg === "")
        {
            PerformDueNow();
        }
        else
        {
            setDueNowAlert({...DueNowAlert, alertTitle: 'Due-Now Restricted', alertMsg:Msg});
            setShowDueNowAlert(true);
        }
    }

    function date_diff_indays(date1, date2) {
        let dt1 = new Date(date1);
        let dt2 = new Date(date2);
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    }

    const PerformDueNow = async() => {
        let gData = props.GridRowData[0];
        if (gData.TableSource == "FromScheduleTable") {
            if (parseInt(gData.SchDetailID) > 0) {
                dueNoweObj["Queue"] = "Scheduled24";
            } else {
                dueNoweObj["Queue"] = "Scheduled";
            }
        }
        else
            dueNoweObj["Queue"] = "OnDemand";

        dueNoweObj["iRefID"] = gData.ConfirmationNo;
        dueNoweObj["ServiceID"] = gData.ServiceID; 
        dueNoweObj["iATSPID"] = gData.iSRATSPID; 
        dueNoweObj["iAssignedVehicleId"] = (gData.iAssignedVehicleId === null || gData.iAssignedVehicleId === '') ? '-1': gData.iAssignedVehicleId;
        dueNoweObj["AssignedDriverId"] = (gData.AssignedDriverId === null || gData.AssignedDriverId === '') ? '-1': gData.AssignedDriverId;
        dueNoweObj["bReturnLeg"] = gData.IsReturnTrip; 
        dueNoweObj["SDID"] = gData.SchDetailID;
        dueNoweObj["iAppID"] = '26';
        dueNoweObj["iUserID"] = loginData.iUserID
        dueNoweObj["WMRUrl"] = '';
        dueNoweObj["ServiceStatus"] = gData.ServiceStatus;
        
        
        let response = await APICom.fetchData("", "TripActions/PerformDueNow", "post", { "Content-Type": "application/json" }, dueNoweObj, null);
        let result = response.data;
        if(result.count > 0)
        {
            setDueNowAlert({...DueNowAlert, alertTitle: 'Due-Now Action', alertMsg:"Due-Now performed successfully."});
            setShowDueNowAlert(true);
        }
        else
        {
            setDueNowAlert({...DueNowAlert, alertTitle: 'Due-Now Action', alertMsg:"Due-Now failed."});
            setShowDueNowAlert(true);
        }
    }

    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        UnMountDueNowComponent();
    }

    const handleDueNowModalClose = () => {
        setShowDueNowAlert(false);
        UnMountDueNowComponent();
    }

    const UnMountDueNowComponent = () => {
        if(props.invokeDueNowComponent)
        {
            props.setDueNowProcessing(false);
            props.RefreshGridData();
            props.setInvokeDueNowComponent(false);
        }
    }

    return(
    <>
         <Modal centered show={showDueNowAlert}  animation={false} >
            <Modal.Header className='unassign_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
            <Modal.Title className="unassign_dialog_title_color">{DueNowAlert.alertTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body><b>{DueNowAlert.alertMsg}</b></Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleDueNowModalClose}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
        <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
        onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} btnCanceText={confirmationModalObj.btnCanceText}
        btnOkText={confirmationModalObj.btnOkText} />
    </>
    );
};

export default DueNow;